import classifications from 'modules/classifications/reducer'
import editor from 'modules/editor/reducer'
import landingpages from 'modules/landingpages/reducer'
import playbook from 'modules/playbook/reducer'
import playbookValidation from 'modules/playbookValidation/reducer'
import { mergeReducers } from 'utils/redux'

export default mergeReducers({
  playbook,
  editor,
  classifications,
  landingpages,
  playbookValidation,
})
